import {isMountedInShell} from '../shellRemote';

// Spelled out rather than built from ARIA_DRAWER_WIDTH_CSS_VAR so Tailwind's
// content scan emits the arbitrary-value class; the test pins the two together.
export const SHELL_LOADER_OVERLAY_RIGHT_CLASS =
  'right-[var(--wb-agent-drawer-width,0px)]';

/**
 * Positioning for the app-level loading overlays (`WorkspaceLoader`,
 * `InstrumentedFloatingWaveLoader`).
 *
 * Standalone, the overlay pins to the viewport and stacks per
 * `standaloneClassName`, which may sit above the W&B nav. In the Forge shell
 * the header and the ARIA drawer are shell-owned chrome that should stay
 * visible and interactive while a page loads, so the overlay instead fills the
 * shell's remote container (which is `position: relative`) minus the width the
 * open drawer reserves (`ARIA_DRAWER_WIDTH_CSS_VAR`, set on `<html>` by
 * `WBAgentChatDrawer`), and stacks below the drawer's `z-[40]` so the drawer
 * also stays on top when it overlays the content instead of sitting beside it.
 */
export function appLoaderOverlayClassName(standaloneClassName: string): string {
  return isMountedInShell()
    ? `absolute inset-y-0 left-0 ${SHELL_LOADER_OVERLAY_RIGHT_CLASS} z-[30]`
    : `fixed inset-0 ${standaloneClassName}`;
}
